import { useMutation } from "react-query";
import userAlertSettingService from "../../services/userAlertSettingService";

const useAddUserAlertSetting = () =>
  useMutation(userAlertSettingService.create);

export default useAddUserAlertSetting;
